import React from 'react'
import { CarruselServices } from '../home/CarruselServices'

export const EspaciosEventos = () => {
  return (
    <div className="home">
      <h1>Aun no te animas? Aqui encontraras todos los espacios donde puedes hacer tu fiesta.</h1>
      <CarruselServices/>
    </div>
  )
}
